const requiredFields = (requiredFields: string[], data: Record<string, string>): string[] => {
    return requiredFields.reduce((result: string[], field: string) => {
      const value = data[field];
      if (!value) {
        return [...result, field];
      } else return result;
    }, []);
  };
  
  const email = (value: string) => {
    const regex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return value && String(value).toLowerCase().match(regex);
  };
  
  const cpf = (value: string) => {
    if (value) {
      const clearedValue = value.replace(/\./g, "").replace(/-/g, "");
  
      let sum = 0;
      let rest;
  
      if (clearedValue === "00000000000") return false;
  
      for (let i = 1; i <= 9; i++)
        sum = sum + parseInt(clearedValue.substring(i - 1, i)) * (11 - i);
      rest = (sum * 10) % 11;
  
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(clearedValue.substring(9, 10))) return false;
  
      sum = 0;
      for (let i = 1; i <= 10; i++)
        sum = sum + parseInt(clearedValue.substring(i - 1, i)) * (12 - i);
      rest = (sum * 10) % 11;
  
      if (rest === 10 || rest === 11) rest = 0;
      if (rest !== parseInt(clearedValue.substring(10, 11))) return false;
      return true;
    }
  };
  
  const phone = (value: string) => value && value.length === 11;
  
  const password = (value: string) => {
    return value && value.length >= 8;
  };
  
  const dateString = (value: string) => {
    try {
      const validLength = value.length === 10;
      const [day, month] = value.split("/");
  
      if (!validLength) return false;
      else if (Number(day) < 1 || Number(day) > 31) return false;
      else if (Number(month) < 1 || Number(month)  > 12) return false;
      else return true;
    } catch {
      return false;
    }
  };
  
  // Função para validar datas no formato brasileiro (DD/MM/YYYY)
  function isValidDate(dateString: string) {
    // Verifica se a data está no formato correto (DD/MM/YYYY)
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!regex.test(dateString)) {
      return false;
    }
  
    // Divide a data em dia, mês e ano
    const [day, month, year] = dateString.split("/").map(Number);
  
    // Verifica se o ano é válido (entre 1900 e 2099, por exemplo)
    if (year < 1900 || year > 2099) {
      return false;
    }
  
    // Verifica se o mês é válido (entre 1 e 12)
    if (month < 1 || month > 12) {
      return false;
    }
  
    // Verifica se o dia é válido para o mês e ano fornecidos
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > lastDayOfMonth) {
      return false;
    }
  
    return true;
  }
  
  // Função para validar a data fornecida na validade do cartão de crédito (MM/YY)
  function isValidDateCredit(dateString: string) {
    // Verifica se a data está no formato correto (MM/YYYY)
    const regex = /^\d{2}\/\d{4}$/;
    if (!regex.test(dateString)) {
      return false;
    }
  
    // Divide a data em mês e ano
    const [month, year] = dateString.split("/").map(Number);
  
    // Verifica se o ano é válido (entre 1900 e 2099, por exemplo)
    if (year < 1900 || year > 2099) {
      return false;
    }
    
    // Verifica se o mês é válido (entre 1 e 12)
    if (month < 1 || month > 12) {
      return false;
    }

    // Verifica se a data é válida: se o ano é maior que o ano atual 
    // OU se o ano é igual, verifica se o mês é maior ou igual ao mês atual
    const currentMonth = new Date().getMonth() + 1
    const currentYear = new Date().getFullYear()

    if (year > currentYear || (year === currentYear && month > currentMonth)) {
      return true;
    }
  
    return false;
  }

  // Função para adicionar um ano (12 meses) na data atual
  function addOneYear() {
    // Obtém a data atual
    const dataAtual = new Date();

    // Adiciona 12 meses à data atual
    dataAtual.setMonth(dataAtual.getMonth() + 12);

    // Formata a data para o formato yyyy-mm-dd
    const ano = dataAtual.getFullYear();
    const mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0'); // +1 porque os meses são indexados de 0 a 11
    const dia = dataAtual.getDate().toString().padStart(2, '0');

    const novaData = `${ano}-${mes}-${dia}`;

    return novaData;
  }
  
  // Função para obter a data atual formatada
function getDateFormated() {
    const dataAtual = new Date();
    const ano = dataAtual.getFullYear();
    const mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2);
    const dia = ('0' + dataAtual.getDate()).slice(-2);
    return ano + '-' + mes + '-' + dia;
}


function getTomorrowsDate() {
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
}

  export const Validation = {
    requiredFields,
    email,
    cpf,
    phone,
    password,
    dateString,
    isValidDate,
    isValidDateCredit,
    addOneYear,
    getDateFormated,
    getTomorrowsDate
  };
  